module.exports = __webpack_public_path__ + "media/images/logo-login-a690dfd403ee2a393d0b8db83927c7cb.png";